<div class="container-fluid mt-2 p-4">
    <div class="row">
        <div class="col">
            <div class="row">
                <h2 class="mat-h2">Locations</h2>
                <span class="mat-body-1">Locations help you manage readers and their activity by associating them with a physical operating site.</span>
            </div>
            <div class="row">
                <div class="col-12">
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                </div>
            </div>
            @if(terminalLocations?.length === 0){
                <div class="row pb-4">
                    <h3 class="mat-h3">No Locations Created</h3>
                </div>
            }
            @if(terminalLocations?.length > 0){
                <div class="row pb-4">
                    <stripe-terminal-locations 
                        [locations]="terminalLocations" 
                        [readers]="terminalReaders" 
                        (createReaderEvent)="addTerminalReader($event)"
                        (deleteReaderEvent)="getTerminalLocations();">
                    </stripe-terminal-locations>
                </div>
            }
            <div class="row">
                <div class="col-2">
                    <button mat-raised-button
                        (click)="addTerminalLocation()"><mat-icon>add</mat-icon>Add Location</button>
                </div>
            </div>

        </div>
    </div>
</div>